import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  text: css``,
  rookie: css`
    --gradient: ${theme.gradients.rookie()};
  `,
  creator: css`
    --gradient: ${theme.gradients.creator()};
  `,
  influencer: css`
    --gradient: ${theme.gradients.influencer()};
  `,
  unicorn: css`
    --gradient: ${theme.gradients.unicorn()};
  `,
  star: css`
    --gradient: ${theme.gradients.star()};
  `,
};

export const root = css`
  position: relative;
  flex-shrink: 0;
  background-color: white;
  padding: 4px;
  aspect-ratio: 1;
  border-radius: 50%;
  overflow: hidden;
  display: inline-block;
  opacity: 0.999; // hack to avoid border to not be displayed
  width: var(--avatar-size, 100px);
  aspect-ratio: 1;
  max-width: 100%;
  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    inset: 0;
    padding: 2px; /* the border thickness */
    border-radius: 50%;
    background: var(--gradient);
    overflow: hidden;
    mask:
      linear-gradient(#000 0 0) exclude,
      linear-gradient(#000 0 0) content-box;
  }
`;

export const avatar = css`
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 8px);
  border-style: solid;
  border-image-slice: 1;
  border-color: transparent;
  object-fit: cover;
  aspect-ratio: 1;
  color: ${theme.colors.neutral['100']};

  &.${variants.text} {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    object-fit: cover;
    aspect-ratio: 1;
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }
`;
